import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import { FormLabel, IconButton, ImageList, Stack } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import type { AssociatedFile } from "../components/associatedFiles/AssociatedFilesView";
import ImagePreview from "../components/imagesPicker/ImagePreview";
import { AddImageDialog } from "./AddImageDialog";

interface Props {
  logo: AssociatedFile | null;
  onSetLogo: (file: FormData) => Promise<void>;
  onDeleteLogo: () => Promise<void>;
}

const CustomerLogo: FC<Props> = ({ logo, onSetLogo, onDeleteLogo }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const columnsCount = 2;
  return (
    <Stack direction="column">
      <FormLabel>Logo</FormLabel>
      <ImageList cols={columnsCount} gap={4} sx={{ maxWidth: `${columnsCount * 100}px`, height: 100 }} rowHeight={100}>
        {logo && (
          <ImagePreview
            image={{ name: logo.name, thumbnail: { url: logo.url }, original: { url: logo.url } }}
            size={100}
          />
        )}
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 2,
          }}
        >
          <IconButton onClick={() => setDialogOpen(true)} aria-label="Edytuj logo">
            <EditIcon />
          </IconButton>
          {logo !== null && (
            <IconButton onClick={onDeleteLogo} aria-label="Usuń logo">
              <DeleteIcon />
            </IconButton>
          )}
        </Stack>
      </ImageList>
      <AddImageDialog open={dialogOpen} onClose={() => setDialogOpen(false)} onNewFile={(f) => onSetLogo(f)} />
    </Stack>
  );
};

export default CustomerLogo;
